import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import sportsSlice from "./slices/sportsSlice";
import myBookingSlice from "./slices/myBookingSlice";
import eventsSlice from "../containers/events-category/slice";

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  myBooking: myBookingSlice,
  sports: sportsSlice,
  events: eventsSlice,
});

export default rootReducer;
